import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import { getCurrentUser } from '@adjust/dashboard-core/api/account';
import { User } from '@adjust/dashboard-core/api/types';
import { GetAuditEventsResponse } from '@api/types';
import { getAuditEvents } from '@api/audit';
import { prepareEventParam } from '@react/constants/historyEvent/utils';
import {
  fetchFailed,
  fetchSuccess,
  getHistoryEventsState,
  HistoryEventsState,
  initialize,
  loadMore,
  TempAngularJSSupporting,
} from '@redux/ducks/historyEvents';

// tasks

export function* fetchHistoryEventsTask({
  payload: { onSuccessToAngularJs, onErrorToAngularJs },
}: Action<TempAngularJSSupporting>) {
  try {
    const { offset, limit, term }: HistoryEventsState = yield select(getHistoryEventsState);
    const user: User = yield call(getCurrentUser);
    const isSuperAdmin = Boolean(user.super_admin);
    const { data }: GetAuditEventsResponse = yield call(getAuditEvents, offset, limit, isSuperAdmin, term);
    const events = data.map(prepareEventParam);
    yield put(fetchSuccess({ events, offset: offset + limit }));

    // TODO remove when AccountHistoryController is migrated
    if (onSuccessToAngularJs) {
      onSuccessToAngularJs(events);
    }
  } catch (e) {
    yield put(fetchFailed());

    // TODO remove when AccountHistoryController is migrated
    if (onErrorToAngularJs) {
      onErrorToAngularJs();
    }
  }
}

// watchers

export function* watchInitialize() {
  yield takeLatest(initialize, fetchHistoryEventsTask);
}

export function* watchLoadMore() {
  yield takeLatest(loadMore, fetchHistoryEventsTask);
}

// saga

export default function* usersSaga() {
  yield all([watchInitialize(), watchLoadMore()]);
}
